import '../src/student/globals'
